
import React, { useState, useEffect } from 'react';
import { Tabs } from 'react-tabs';
import { useLanguage } from '../../../context/language';
import { useHistory } from 'react-router-dom';
import { getAceiteTermos, getPSE } from '../../../api/fastcoinService';
import { formatMs } from '@material-ui/core';
import { getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import Loading from '../../../assets/loading.gif';
import { getWallet } from '../../../api/fastcoinService';

const Wallet = () => {
    const history = useHistory();
    const { lang, orderFromDeposit, translate } = useLanguage();
    const [modal, setModal] = useState(false);
    const [termos, setTermos] = useState(false);
    const [showTermos, setShowTermos] = useState(true);
    const [allowEmail, setAllowEmail] = useState(false);
    const [doc, setDoc] = useState(false);
    const [loadingCheckterms, setLoadingCheckterms] = useState(true);
    const [urlWalletFrame, setUrlWalletFrame] = useState(sessionStorage.getItem("urlWalletFrame") !== null ? sessionStorage.getItem("urlWalletFrame") : undefined);
    const [show, setShow] = useState(sessionStorage.getItem("popup_frame") != true ? false : true);
    const handleClose = () => { sessionStorage.setItem("popup_frame", false); setShow(false); };
    const [mensageModal, setMensageModal] = useState("");
    const [tituloModal, setTituloModal] = useState("Error!");
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [loading, setLoanding] = useState(true);
    const [screenWallet, setScreenWallet] = useState(); 
    const [iframeMain, setIframeMain] = useState("iframe-main");


    useEffect(() => {
        let country = sessionStorage.getItem("country");
        let broker = sessionStorage.getItem("broker");
        let order_no = sessionStorage.getItem("order_no");
        if (country === null || broker === null || order_no === null || country.length === 0 || broker.length === 0 || order_no.length === 0) {
            return (
                <>
                    {history.push("/404", { country: country, broker: broker, order_no: order_no, from: history.location.pathname })}
                </>
            );
        }

        if(country.toLowerCase()==='co'){        
           
            setIframeMain("iframe-main-co"); 
        };


    }, []);

    function toggle() {
        setModal(!modal);
    }

    useEffect(() => {
        if (orderFromDeposit !== "") {
            validarTermos();
        }
    }, [orderFromDeposit]);


    useEffect(() => {
        if (allowEmail === true && sessionStorage.getItem("order_no") !== null && termos === true) {
            setLoadingCheckterms(true);
            setAllowEmail(false);
            setTermos(false);
        }

    }, [allowEmail, termos]);

    useEffect(() => {
        translate();
    }, [modal, translate, /*showTermos, loadingCheckterms*/]);

    const aceitetermos = (confirm = null) => {
        setTermos(!termos);
        if (confirm === true && doc === true) {
            sessionStorage.setItem("documento_cliente", document.getElementsByName("docNumber").item(0).value);
            toggle();
            setAllowEmail(true);
        }
    };

    const mostrarInformacoesPgto = () => {
        if (termos && doc) {
            sessionStorage.setItem("documento_cliente", document.getElementsByName("docNumber").item(0).value);
            setAllowEmail(true);
        }
    };

    const changeDoc = (state) => {
        setDoc(state);
    };

    function validarTermos() {        
        getAceiteTermos(sessionStorage.getItem("order_no"))
            .then(res => {
                if (res !== undefined) {
                    setShowTermos(false);                                       
                       
                    if (urlWalletFrame === undefined) {
                         console.log("URL indefinida")                      
                        gerarFrame();
                        checkPayment();
                    }
                    else {                         
                        setUrlWalletFrame(sessionStorage.getItem("urlWalletFrame"));
                        checkPayment();
                    }
                }
                else {
                    setShowTermos(true);
                }
            })
            .catch(err => {
                if (err.error("Could not find")) {
                    //console.log(err);
                } else {
                    //console.log(err);
                    alert("Please talk with the administrator");
                }
                setShowTermos(true);
            })
            .finally(() => {
               setLoadingCheckterms(false);
            });
    }

    function gerarFrame() { 
           
        let amount = sessionStorage.getItem("order_amount");
        let order_no = sessionStorage.getItem("order_no");
        let nomeClient = sessionStorage.getItem("full_Name");
        let documentClient = sessionStorage.getItem("documento_cliente");
        let email = sessionStorage.getItem("email");        

        getWallet(amount, order_no, nomeClient, documentClient, email)
            .then(res => {
               
                if (res.msg !== "Success") {
                    setMensageModal(res);                    
                    console.log(res);
                }
               else {
                    let payment_url = (res.web_url);                                     
                   console.log(payment_url);
                   sessionStorage.setItem("urlWalletFrame", payment_url);
                   setUrlWalletFrame(sessionStorage.getItem("urlWalletFrame"));                                 
                        
                } 
            })          

            .catch(err => {
                console.log(err.toString());
            });

    }    
    
    useEffect(() => {

        if (mensageModal) {
            setShow(true);
        };

        if(urlWalletFrame !== undefined){
            setLoanding(false); 
        }
        
    }, [mensageModal, loading, urlWalletFrame]);

    function checkPayment() {
        setTimeout(function () {
            getDeposit(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res.status.toLowerCase() === "paid") {
                        setWaitingPayment(false);
                        sessionStorage.setItem("waiting_payment", false);
                        window.location.replace(getURLBackToPanel());
                    } else {
                        checkPayment();
                    }
                })
                .catch(err => {
                    alert(err);
                    checkPayment();
                });
        }, 30000);
    }
    
    return (

        <div>         
            <div>
                <div>
                    <Tabs>
                        <div>
                        <div className="info-deposit-title">
                                <Tabs>
                                    {!loading ?                                    
                                        <iframe src={urlWalletFrame} className={iframeMain}></iframe>
                                    :                                   
                                    <div className="centered-loading-terms-deposit">                            
                                        <img src={Loading} alt={"loading"} width="30px" height="30px" />
                                    </div>                                    
                                    }
                                </Tabs>
                            </div>
                        </div>
                    </Tabs>
                </div>
            </div>
        </div>

    )};    

export default Wallet